// blog26.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "../allcss/blog18.css";
import blogImage from "../Asets/Blog.jpg"; // hero background
import detailImg from "../Asets/blog2626.png"; // detail image for blog 26
import Header from "../components/header";
import Footer from "../components/footer";

const Blog26 = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div
          className="blog-hero"
          style={{ backgroundImage: `url(${blogImage})` }}
        >
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: "pointer", color: "#fff" }}
                onClick={() => navigate("/")}
              >
                Home
              </span>
              <span> / Our Blog / Developing Social Skills in Early Years</span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">
            Developing Social Skills in Early Years – Red School House’s Proven Approach
          </h2>
          <br />
          <div className="published-badge">Published on: 21 November 2025</div>
          <br />

          <img
            src={detailImg}
            alt="Developing Social Skills in Early Years – Red School House Vadodara"
            className="blog-detail-img"
          />

          <div className="blog-detail-content">

            <p>
              The early years of childhood are crucial, not only for academic learning but
              also for building meaningful life skills — especially social skills.
              These include sharing, expressing feelings, cooperating with others,
              resolving conflicts, and developing empathy.
            </p>

            <p>
              At <strong>Red School House Vadodara</strong>, widely recognized as the 
              <strong> best preschool in Harni, Vadodara</strong>, we focus on nurturing
              these skills naturally through guided play, interactive learning,
              and a supportive school environment.
            </p>

            <p>
              Social development shapes how children communicate and connect with the world —
              and preschool is the perfect place where these essential skills begin to grow.
            </p>

            <hr />

            <h3>Why Social Skills Matter in Early Childhood</h3>
            <p>Strong social skills help children:</p>
            <ul>
              <li>Build healthy friendships</li>
              <li>Develop confidence</li>
              <li>Learn patience and cooperation</li>
              <li>Express thoughts respectfully</li>
              <li>Solve problems peacefully</li>
            </ul>

            <p>
              Children who develop strong social skills early often grow into confident
              communicators, empathetic individuals, and emotionally intelligent learners.
            </p>

            <hr />

            <h3>Red School House’s Proven Approach to Building Social Skills</h3>
            <p>
              At Red School House Vadodara — the best preschool in Harni, Vadodara,
              social growth is integrated into everyday learning.
            </p>

            <h4>1️⃣ Play-Based Interaction</h4>
            <p>
              Children learn best through play. Group games, building activities,
              pretend play, and outdoor exploration help children work together,
              take turns, and communicate naturally.
            </p>

            <h4>2️⃣ Circle Time Communication</h4>
            <p>Daily circle time encourages children to:</p>
            <ul>
              <li>Share ideas</li>
              <li>Talk about their day</li>
              <li>Listen to others</li>
              <li>Develop confidence while speaking</li>
            </ul>

            <h4>3️⃣ Team Activities and Collaborative Learning</h4>
            <p>
              Group art projects, music sessions, and storytelling activities
              strengthen teamwork and help children understand the importance of
              cooperation and patience.
            </p>

            <h4>4️⃣ Role-Playing Real-Life Situations</h4>
            <p>Teachers guide children through role-play scenarios like:</p>
            <ul>
              <li>Sharing toys</li>
              <li>Helping a friend</li>
              <li>Expressing feelings</li>
              <li>Solving disagreements</li>
            </ul>

            <h4>5️⃣ Supportive Teachers as Social Guides</h4>
            <p>
              Teachers model kindness, respect, and communication. With gentle guidance,
              children learn:
            </p>
            <ul>
              <li>How to respond politely</li>
              <li>How to manage emotions</li>
              <li>How to build friendships</li>
            </ul>

            <hr />

            <h3>Benefits of Social Skill Development at Red School House</h3>
            <ul>
              <li>✔ Improved confidence</li>
              <li>✔ Better communication skills</li>
              <li>✔ Increased empathy and emotional balance</li>
              <li>✔ Strong bonding and friendship skills</li>
              <li>✔ Positive behavior and self-discipline</li>
            </ul>

            <hr />

            <h3>Contact Details</h3>
            <p>
              📍 <strong>Address:</strong> A-25, Castle White, Opp. Main Harni Water Tank,
              Harni Sama Link Road, Vadodara – 390008
              <br />
              📞 <strong>Phone:</strong>{" "}
              <a href="tel:+917778851070">+91 77788 51070</a>
              <br />
              📧 <strong>Emails:</strong>{" "}
              <a href="mailto:redschoolhousebaroda2025@gmail.com">
                redschoolhousebaroda2025@gmail.com
              </a>{" "}
              |{" "}
              <a href="mailto:redschoolhousebaroda@gmail.com">
                redschoolhousebaroda@gmail.com
              </a>
              <br />
              🌐 <strong>Website:</strong>{" "}
              <a
                href="https://redhouseschoolvadodara.in/"
                target="_blank"
                rel="noreferrer"
              >
                redhouseschoolvadodara.in
              </a>
              <br />
              📸 <strong>Instagram:</strong>{" "}
              <a
                href="https://www.instagram.com/redschoolhousebaroda/"
                target="_blank"
                rel="noreferrer"
              >
                instagram.com/redschoolhousebaroda
              </a>
            </p>

            <p className="blog-tags">
              #RedSchoolHouseVadodara &nbsp;
              #BestPreschoolInHarni &nbsp;
              #ChildSocialSkills &nbsp;
              #EarlyChildhoodDevelopment &nbsp;
              #VadodaraPreschools
            </p>

            {/* Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate("/blog")}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog26;
